<template>
  <custom-callout
    :border-color="statusColor.color"
    class-main="mt-3 rounded"
    :controlled="true"
    :has-toggle="false"
    :opened="opened"
    @click:open="toggleCallout"
  >
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col-12 col-md-2 text-center border-right mr-5">
        <div class="d-flex flex-column font-weight-bold color-black">
          <span
            :class="`mb-1 badge badge-pill font-14 pt-2 pb-2 w-70 mx-auto`"
            :style="`${statusColor.badged}`"
          >
            {{ data.statusName | empty }}
          </span>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Tipo de Proveedor:</div>
        <div class="color-black font-16">
          {{ data.providerType | empty }}
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Nombre:</div>
        <div class="color-black font-16">
          {{ data.name | empty }}
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Número Patronal:</div>
        <div class="color-black font-16">
          {{ data.ssn | empty }}
        </div>
      </div>
      <div
        class="col col-sm col-12 d-flex align-items-center justify-content-end"
      >
        <drop-down class="ml-2" :items="actionItems" />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import ServiceStatusColors from '@/utils/constants/requestServiceStatusColors';
import ProviderState from '@/utils/constants/providerStates.js';

export default {
  name: 'ProviderResultRow',
  components: {
    CustomCallout,
    DropDown,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    opened: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    toggleCallout() {
      let value = this.index;
      if (this.opened) value = null;
      this.$emit('set-active-index', value);
    },
  },
  computed: {
    actionItems() {
      return [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import color-green',
          click: () => this.$emit('on-view-provider'),
        },
        {
          label: 'Perfil del Proponente',
          icon: 'fas fa-file-search color-green',
          click: () => this.$emit('on-view-provider-profile'),
        },
        {
          label: 'Ver Documentos',
          icon: 'fas fa-file-search color-green',
          click: () => this.$emit('on-view-documents'),
          border: 'top',
          visible: this.data.academicYearId !== null,
        },
      ];
    },
    statusColor() {
      switch (this.data.statusName) {
        case ProviderState.Inactive:
          return {
            color: ServiceStatusColors.Gray,
            badged: 'background-color: #b5c3bc',
          };
        case ProviderState.Active:
          return {
            color: ServiceStatusColors.GreenLight,
            badged: 'background-color: #A3E5B3',
          };
        default:
          return null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.btn-action-size {
  width: 35px;
  height: 35px;
}
</style>
